import { api } from './api';

const get = async () => {
  try {
    const { data } = await api.get(`/geoInterface/all`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getGeoInterfaces = async () => {
  try {
    const { data } = await api.get('/geoInterface');
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export default {
  get,
  getGeoInterfaces
};
